import React from 'react';
import { Modal, BackdropBackgroundModes, VerticalPositionModes } from '@nearpod-packages/core';
import classNames from 'classnames';
import styles from './ActivityUnavailable.scss.js';
import unavailableBanner from '../../../../assets/ThumbnailBanner/unavailable-banner.png.js';
import { useCustomTranslation } from '../../../../hooks/useCustomTranslation/useCustomTranslation.js';

const ActivityUnavailable = _ref => {
  let {
    isOpen = true,
    containerRef
  } = _ref;
  const {
    tCustom
  } = useCustomTranslation();
  return /*#__PURE__*/React.createElement(Modal, {
    containerRef: containerRef,
    backdropBackground: BackdropBackgroundModes.whiteGradient,
    verticalPositionOnContainer: VerticalPositionModes.top,
    isOpen: isOpen,
    onClose: () => {},
    disableFocusTrap: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['modal-content']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${unavailableBanner})`
    },
    className: styles['modal-content__banner']
  }, /*#__PURE__*/React.createElement("p", {
    className: styles['modal-content__banner__text']
  }, tCustom('UNAVAILABLE'))), /*#__PURE__*/React.createElement("h2", {
    className: classNames([styles['modal-content__title']])
  }, tCustom('FLIP_TITLE')), /*#__PURE__*/React.createElement("p", {
    className: classNames([styles['modal-content__description']])
  }, tCustom('FLIP_DESCRIPTION'))));
};
var ActivityUnavailable$1 = ActivityUnavailable;

export { ActivityUnavailable$1 as default };
//# sourceMappingURL=ActivityUnavailable.js.map
